import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('../components/login/Login.vue')
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('../components/Dashboard.vue')
    },
    {
      path: '/result',
      name: 'result',
      component: () => import('../components/Result.vue')
    },
    // {
    //   path: '/manage',
    //   name: 'manage',
    //   component: () => import('../components/Manage.vue')
    // },
    // {
    //   path: '/registration',
    //   name: 'registration',
    //   component: () => import('../components/Registration.vue')
    // },
    // {
    //   path: '/profile',
    //   name: 'profile',
    //   component: () => import('../components/Profile.vue')
    // },
    {
      path: '/bulkDownload',
      name: 'bulkDownload',
      component: () => import('../components/BulkDownload.vue')
    },
    {
      path: '/learningResources',
      name: 'learningResources',
      component: () => import('../components/LearningResources.vue')
    }
  ]
})
